import Header from "../../../design-system/components/Header/Header.jsx";
import tokens from "../../../design-system/tokens.js";
import { ShellContent } from "../../shell/Shell.jsx";
import SegmentedToggle from "../../../design-system/components/SegmentedToggle/SegmentedToggle.jsx";
import StudentsOverview from "./students/StudentsOverview.jsx";
import TeachersOverview from "./teachers/TeachersOverview.jsx";

const tabs = [
  {
    label: "Schüler*innen",
    value: "students",
    content: <StudentsOverview />,
  },
  {
    label: "Kolleg*innen",
    value: "teachers",
    content: <TeachersOverview />,
  },
];

const InviteOverview = () => {
  return (
    <ShellContent bg={tokens.color.full.gray800}>
      <SegmentedToggle tabs={tabs} defaultValue="students">
        <Header
          title={"Einladen"}
          back
          backPath={".."}
          isDarkMode
          hasBorder={false}
        >
          <SegmentedToggle.List
            tabs={tabs}
            ariaLabel="Einzuladende Personengruppe auswählen"
          />
        </Header>
      </SegmentedToggle>
    </ShellContent>
  );
};

export default InviteOverview;
